"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/product_kind.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.productKindToJSON = exports.productKindFromJSON = exports.ProductKind = exports.pledgeProductKindToJSON = exports.pledgeProductKindFromJSON = exports.PledgeProductKind = void 0;
/* eslint-disable */
/**
 * DEPRECATED: use ProductKind instead
 *
 * @deprecated
 */
exports.PledgeProductKind = {
    PLEDGE_PRODUCT_KIND_UNSPECIFIED: "PLEDGE_PRODUCT_KIND_UNSPECIFIED",
    PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN: "PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN",
    PLEDGE_PRODUCT_KIND_BOND: "PLEDGE_PRODUCT_KIND_BOND",
    PLEDGE_PRODUCT_KIND_MINIBON: "PLEDGE_PRODUCT_KIND_MINIBON",
    PLEDGE_PRODUCT_KIND_DONATION: "PLEDGE_PRODUCT_KIND_DONATION",
    PLEDGE_PRODUCT_KIND_BELGIUM_LOAN: "PLEDGE_PRODUCT_KIND_BELGIUM_LOAN",
    PLEDGE_PRODUCT_KIND_PRIVATE_DEBT: "PLEDGE_PRODUCT_KIND_PRIVATE_DEBT",
    PLEDGE_PRODUCT_KIND_MERCHANT: "PLEDGE_PRODUCT_KIND_MERCHANT",
    PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND: "PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function pledgeProductKindFromJSON(object) {
    switch (object) {
        case 0:
        case "PLEDGE_PRODUCT_KIND_UNSPECIFIED":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED;
        case 1:
        case "PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN;
        case 2:
        case "PLEDGE_PRODUCT_KIND_BOND":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_BOND;
        case 3:
        case "PLEDGE_PRODUCT_KIND_MINIBON":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_MINIBON;
        case 4:
        case "PLEDGE_PRODUCT_KIND_DONATION":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_DONATION;
        case 5:
        case "PLEDGE_PRODUCT_KIND_BELGIUM_LOAN":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_BELGIUM_LOAN;
        case 6:
        case "PLEDGE_PRODUCT_KIND_PRIVATE_DEBT":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_PRIVATE_DEBT;
        case 7:
        case "PLEDGE_PRODUCT_KIND_MERCHANT":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_MERCHANT;
        case 8:
        case "PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND":
            return exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.PledgeProductKind.UNRECOGNIZED;
    }
}
exports.pledgeProductKindFromJSON = pledgeProductKindFromJSON;
function pledgeProductKindToJSON(object) {
    switch (object) {
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED:
            return "PLEDGE_PRODUCT_KIND_UNSPECIFIED";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN:
            return "PLEDGE_PRODUCT_KIND_PARTICIPATORY_LOAN";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_BOND:
            return "PLEDGE_PRODUCT_KIND_BOND";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_MINIBON:
            return "PLEDGE_PRODUCT_KIND_MINIBON";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_DONATION:
            return "PLEDGE_PRODUCT_KIND_DONATION";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_BELGIUM_LOAN:
            return "PLEDGE_PRODUCT_KIND_BELGIUM_LOAN";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_PRIVATE_DEBT:
            return "PLEDGE_PRODUCT_KIND_PRIVATE_DEBT";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_MERCHANT:
            return "PLEDGE_PRODUCT_KIND_MERCHANT";
        case exports.PledgeProductKind.PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND:
            return "PLEDGE_PRODUCT_KIND_CONVERTIBLE_BOND";
        case exports.PledgeProductKind.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.pledgeProductKindToJSON = pledgeProductKindToJSON;
exports.ProductKind = {
    PRODUCT_KIND_UNSPECIFIED: "PRODUCT_KIND_UNSPECIFIED",
    PRODUCT_KIND_PARTICIPATORY_LOAN: "PRODUCT_KIND_PARTICIPATORY_LOAN",
    PRODUCT_KIND_BOND: "PRODUCT_KIND_BOND",
    PRODUCT_KIND_MINIBON: "PRODUCT_KIND_MINIBON",
    PRODUCT_KIND_DONATION: "PRODUCT_KIND_DONATION",
    PRODUCT_KIND_BELGIUM_LOAN: "PRODUCT_KIND_BELGIUM_LOAN",
    PRODUCT_KIND_PRIVATE_DEBT: "PRODUCT_KIND_PRIVATE_DEBT",
    PRODUCT_KIND_MERCHANT: "PRODUCT_KIND_MERCHANT",
    PRODUCT_KIND_CONVERTIBLE_BOND: "PRODUCT_KIND_CONVERTIBLE_BOND",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function productKindFromJSON(object) {
    switch (object) {
        case 0:
        case "PRODUCT_KIND_UNSPECIFIED":
            return exports.ProductKind.PRODUCT_KIND_UNSPECIFIED;
        case 1:
        case "PRODUCT_KIND_PARTICIPATORY_LOAN":
            return exports.ProductKind.PRODUCT_KIND_PARTICIPATORY_LOAN;
        case 2:
        case "PRODUCT_KIND_BOND":
            return exports.ProductKind.PRODUCT_KIND_BOND;
        case 3:
        case "PRODUCT_KIND_MINIBON":
            return exports.ProductKind.PRODUCT_KIND_MINIBON;
        case 4:
        case "PRODUCT_KIND_DONATION":
            return exports.ProductKind.PRODUCT_KIND_DONATION;
        case 5:
        case "PRODUCT_KIND_BELGIUM_LOAN":
            return exports.ProductKind.PRODUCT_KIND_BELGIUM_LOAN;
        case 6:
        case "PRODUCT_KIND_PRIVATE_DEBT":
            return exports.ProductKind.PRODUCT_KIND_PRIVATE_DEBT;
        case 7:
        case "PRODUCT_KIND_MERCHANT":
            return exports.ProductKind.PRODUCT_KIND_MERCHANT;
        case 8:
        case "PRODUCT_KIND_CONVERTIBLE_BOND":
            return exports.ProductKind.PRODUCT_KIND_CONVERTIBLE_BOND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.ProductKind.UNRECOGNIZED;
    }
}
exports.productKindFromJSON = productKindFromJSON;
function productKindToJSON(object) {
    switch (object) {
        case exports.ProductKind.PRODUCT_KIND_UNSPECIFIED:
            return "PRODUCT_KIND_UNSPECIFIED";
        case exports.ProductKind.PRODUCT_KIND_PARTICIPATORY_LOAN:
            return "PRODUCT_KIND_PARTICIPATORY_LOAN";
        case exports.ProductKind.PRODUCT_KIND_BOND:
            return "PRODUCT_KIND_BOND";
        case exports.ProductKind.PRODUCT_KIND_MINIBON:
            return "PRODUCT_KIND_MINIBON";
        case exports.ProductKind.PRODUCT_KIND_DONATION:
            return "PRODUCT_KIND_DONATION";
        case exports.ProductKind.PRODUCT_KIND_BELGIUM_LOAN:
            return "PRODUCT_KIND_BELGIUM_LOAN";
        case exports.ProductKind.PRODUCT_KIND_PRIVATE_DEBT:
            return "PRODUCT_KIND_PRIVATE_DEBT";
        case exports.ProductKind.PRODUCT_KIND_MERCHANT:
            return "PRODUCT_KIND_MERCHANT";
        case exports.ProductKind.PRODUCT_KIND_CONVERTIBLE_BOND:
            return "PRODUCT_KIND_CONVERTIBLE_BOND";
        case exports.ProductKind.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.productKindToJSON = productKindToJSON;
//# sourceMappingURL=product_kind.js.map